import api from "../api/axios";

const priceTierService = {
  getAll: () => api.get("PriceTier"),
  create: (data) => api.post("PriceTier", data),
  update: (data) => api.put("PriceTier", data),
  delete: (id) => api.delete(`PriceTier/${id}`),
  getProducts: (id) => api.get(`PriceTier/${id}/products`),
  getProductsForNew: () => api.get("PriceTier/products"),
};

export default priceTierService;
